import type { RelationType, WhereType } from "./answers";

export const WHERE_OPTIONS: { value: WhereType; label: string }[] = [
  { value: "hospital", label: "Hospital" },
  { value: "private_residence", label: "Private residence" },
  { value: "care_facility", label: "Care facility" },
  { value: "medical_examiner", label: "Medical examiner" },
  { value: "other", label: "Other" },
];

export const RELATION_OPTIONS: { value: RelationType; label: string }[] = [
  { value: "spouse", label: "Spouse" },
  { value: "parent", label: "Parent" },
  { value: "adult_child", label: "Adult child" },
  { value: "child", label: "Child" },
  { value: "grandparent", label: "Grandparent" },
  { value: "power_of_attorney", label: "Power of attorney" },
  { value: "other", label: "Other" },
];
